<template>
<nav class="navbar navbar-expand-lg navbar-light bg-light ">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">NetToWin AG    <p style="display: inline; font-size: 0.9rem; text-align: center;"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Anmeldename: &nbsp;&nbsp;{{benutzerName}} </p></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a @click.prevent="action('Home')" class="nav-link active" aria-current="page" >Home</a>
        </li>
        <li v-if="IsInFunctionalRole('MasterAdmin')" class="nav-item">
          <a @click.prevent="action('DocumentManagement')" class="nav-link active" aria-current="page" >Dokumentenverwaltung</a>
        </li>
        <li class="nav-item">
          <a @click.prevent="action('RecordMalfunction')" class="nav-link active" aria-current="page" >Kundendienst</a>
        </li>
        <li v-if="IsInFunctionalRole('MasterAdmin')" class="nav-item">
          <a @click.prevent="action('ShowDeviceData')" class="nav-link active" aria-current="page" >Rechnungsinfo</a>
        </li>        
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle menu__color--adjust" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Control-Center
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li @click.prevent="action('ControlCenter')"><a class="dropdown-item">Monitoring</a></li>
            <!-- <li><hr class="dropdown-divider"></li> -->
          </ul>
        </li>
        <li v-if="IsInFunctionalRole('MasterAdmin')" class="nav-item">
          <a  @click.prevent="action('Stammdaten')" class="nav-link menu__color--adjust" tabindex="-1" aria-disabled="false">Stammdaten</a>
        </li>

        <li v-if="IsInFunctionalRole('MasterAdmin')" class="nav-item">
          <a  @click.prevent="action('Report')" class="nav-link menu__color--adjust" tabindex="-1" aria-disabled="false">Report</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle menu__color--adjust" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Profil
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li @click.prevent="action('ChangePassword')"><a class="dropdown-item">Kennwort</a></li>
            <!-- <li><hr class="dropdown-divider"></li> -->
          </ul>
        </li>
        <li class="nav-item">
          <a  @click.prevent="action('Logout')" class="nav-link menu__color--adjust" tabindex="-1" aria-disabled="false">Abmelden</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
 <div>
    <router-view />
      </div>
</template>

<script language="ts">
// import { defineComponent } from "vue";
//import Sidebar from "@/components/Navigation/Sidebar.vue";
import { ref } from "vue"
import { useRouter} from "vue-router"
import router from "@/router/index";
import { useStore } from "vuex";
import { apiPost , apiPostGetPdf} from "@/services/api/fetchapi";
import { UserProfile } from "@/infrastructure/backend/userProfile";


export default {
  name: "Home",
  inheritAttrs: false,
  components: {},
  emits: ["Logout"],
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props,context) {
    useRouter;

    const store = new useStore();
    let cnt = 0;

    const benutzerName = ref("");
    const isReportAllowed = ref(false);


    router.push({ name: "HomeContent" });


    function IsInFunctionalRole(functionalRoleName) {
        return UserProfile.IsInFunctionalRole(functionalRoleName)
    }


    function action( actionName ) {
      // if ( actionName === "Report" ) {
      //       getReport()
      // }
      if (actionName === "Home") {
        router.push({ name: "HomeContent" });
      }
      if (actionName === "ControlCenter") {
        router.push({ name: "ControlCenter" });
      }
      if (actionName === "Logout") {
        console.log(actionName);
        context.emit("Logout", "ok");
      }
      if (actionName === "ChangePassword") {
        console.log(actionName);
        router.push({ name: "ChangePassword" });
      }
      if (actionName === "DocumentManagement") {
        console.log(actionName);
        router.push({ name: "DocumentManagement" });
      }
      if (actionName === "ShowDeviceData") {
        console.log(actionName);
        router.push({ name: "ShowDeviceData" });
      }
      if (actionName === "RecordMalfunction") {
        console.log(actionName);
        cnt++;
        router.push({ name: "RecordMalfunction", query: { refresh: cnt } });
      }
      if (actionName === "Report") {
        console.log(actionName);
        router.push({ name: "CreateCustomerDocuments" });
      }
      if (actionName === "Stammdaten") {
        router.push({ name: "Stammdaten" });
      }
    }

    async function getUserInfo() {
      const response = await apiPost("ComponentView/getUserInfo", {
        userId: store.getters["userstore/getUser"],
      });

      benutzerName.value = response.personFullName;
    }

    async function isReportRole() {
      const response = await apiPost("ComponentView/isBerichtRoleAllowed", {
        userId: store.getters["userstore/getUser"],
      });
      isReportAllowed.value = response.success;
    }

    


    // async function getReport() {
    //   await apiPostGetPdf("ComponentView/getReportingData", {
    //     url:
    //       "http://appl1.nettowin.ch/ReportServer_SQLEXPRESS/Pages/ReportViewer.aspx?%2fWeb3+Berichte%2fTest_Rechnung&rs:Format=pdf&idBereich=1073743115",
    //   });
    // }

//getReport();

// let headers = new Headers();
// headers.append('Content-Type', 'application/json');

// fetch(process.env.VUE_APP_API + "/" + "ComponentView/getReportingData", {
//     method: 'POST',
//     headers: headers,
//     body: JSON.stringify({
//     url: "http://appl.nettowin.ch/ReportServer_SQLEXPRESS/Pages/ReportViewer.aspx?%2fWeb3+Berichte%2fTest_Rechnung&rs:Format=pdf&idBereich=1073743115"
//     })
// })
//     .then(async res => ({
//         //filename: fnGetFileNameFromContentDispostionHeader(res.headers.get('content-disposition')),
//         blob: await res.blob()
//     }))
//     .then(resObj => {
//         // It is necessary to create a new blob object with mime-type explicitly set for all browsers except Chrome, but it works for Chrome too.
//         const newBlob = new Blob([resObj.blob], { type: 'application/pdf' });

//         // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
//         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
//             window.navigator.msSaveOrOpenBlob(newBlob);
//         } else {
//             // For other browsers: create a link pointing to the ObjectURL containing the blob.
//             const objUrl = window.URL.createObjectURL(newBlob);

//             let link = document.createElement('a');
//             link.href = objUrl;
//             link.download = resObj.filename;
//             link.click();

//             // For Firefox it is necessary to delay revoking the ObjectURL.
//             setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
//         }
//     })
//     .catch((error) => {
//         console.log('DOWNLOAD ERROR', error);
//     });

    getUserInfo();
    isReportRole();

    return {
      action,
      benutzerName,
      isReportAllowed,
      IsInFunctionalRole
    };
  },
};
</script>
<style scoped>

.menu__color--adjust {
  color: rgba(0, 0, 0, 0.9) !important;
}


.float-sidebar {
  min-height: 100vh;
  height: 100vh;;
  overflow-y: hidden;
  float: left;
  min-width: 180px;
  max-width: 180px;
  background: rgb(4, 6, 121);
  background-image: linear-gradient(
    120deg,
    rgb(100, 200, 248),
    rgb(50, 100, 220)
  );
  background-size: 100%;
}

.float-content {
  min-height: 100vh;
  height: 100vh;
  overflow-y: hidden;
  float: left;
  width: calc(100% - 180px);
  background-color: white;
}

.noScrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}
.test {
  border: 2px solid lightblue;
}
</style>
